// src/components/TipPickerWithThanks.js
import React, { useState } from "react";
import './tipPicker.css';
import ThankYouAnimation from "./ThankYouAnimation";
import { I18n } from "react-redux-i18n";
import auth from "../js/auth";

const TIP_OPTIONS = [0, 5, 10, 15];

var t;

export default function TipPickerWithThanks({ onTipSelected, thanks, basePrice, myStatus }) {
    const [selectedTip, setSelectedTip] = useState(null);
    const tips = myStatus?.restaurant_settings["enabled-features"]?.pos?.tips || TIP_OPTIONS;
    const [pulsingTip, setPulsingTip] = useState(tips[0]);



    React.useEffect(() => {
        let idx = 0;
        const interval = setInterval(() => {
            idx = (idx + 1) % tips.length;
            setPulsingTip(tips[idx]);
        }, 700); // Change speed as needed
        return () => clearInterval(interval);
    }, []);

    const handleTipClick = (tip) => {
        setSelectedTip(tip);
        if (onTipSelected) {
            if (t) clearTimeout(t);
            t = setTimeout(() => {
                onTipSelected(tip);
            }, 2000);
        }
    };

    const handleThanksFinish = () => {
        // proceed to card payment here
    };

    return !thanks ? (
        <div className="tip-picker-container">
            <div className="tip-picker-prompt">
                {I18n.t("admin_local.Please pick a tip to proceed to payment!").split('<br>').map((line, index) => (
                    <React.Fragment key={index}>
                        <div>{line}</div>
                    </React.Fragment>
                ))}
            </div>
            <div className="tip-picker-buttons">
                {tips.map((tip) => (
                    <button
                        key={tip}
                        onClick={() => handleTipClick(tip)}
                        className={
                            `tip-picker-tipButton` +
                            (tip === selectedTip ? ' tip-picker-selectedTipButton' : '') +
                            (tip === pulsingTip ? ' tip-picker-pulse' : '')
                        }
                    >
                        <div className="tip-picker-tip-percent">{`+ ${tip}%`}</div>
                        <div className="tip-picker-tip-amount">{`${auth.round((basePrice * tip) / 100)} ${myStatus.restaurant_base_currency.name}`}</div>
                    </button>
                ))}
            </div>
        </div>
    ) : (
        <div className="tip-picker-thanks">
            <ThankYouAnimation onFinish={handleThanksFinish} />
        </div>
    );


}


